export default __webpack_public_path__ + "static/bgContactYellow-22bc9fad202dc32dee4c6cc2dd8ef2b4.png";